<ion-header
  class="ion-no-border"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      slot="end"
    >
      <ion-button
        data-cy="close-modal-button"
        class="close-modal-button"
        (click)="closeModal()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-label *ngIf="!isEditing">
      {{ 'i18n.orderPage.addAddlInstructions' | translate }}
    </ion-label>
    <ion-label *ngIf="isEditing">
      {{ 'i18n.orderPage.editAddlInstructions' | translate }}
    </ion-label>

    <h4>{{ 'i18n.orderPage.addlInstructions1' | translate }}</h4>

    <p>
      <span>{{ 'i18n.orderPage.addlNote' | translate }}</span>
      {{ 'i18n.orderPage.addlInstructions2' | translate }}
    </p>
  </ion-toolbar>
</ion-header>

<ion-content
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <ion-item>
    <ion-input
      [(ngModel)]="internalInstructions"
      (input)="handleInputChange($event)"
      data-cy="addl-instructions-modal-input"
      maxlength="30"
      placeholder="{{ 'i18n.orderPage.maxLInstructions' | translate }}"
      required="true"
    ></ion-input>
  </ion-item>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        class="usf-outline-green-dsktp-tblt-modal-button"
        data-cy="addl-instructions-cancel-button"
        (click)="closeModal()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        class="usf-fill-green-dsktp-tblt-modal-button"
        data-cy="addl-instructions-save-button"
        (click)="saveModal()"
      >
        {{ 'i18n.common.save' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
